import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Teams = () => {
  return (
    <EmptyPage
      title="Team Settings"
      description="Organize users into teams, set team-specific permissions, and manage collaborative workflows for your real estate projects."
      icon="👨‍👩‍👧‍👦"
    />
  );
};

export default Teams;
